import {useCallback, useEffect} from 'react'

import type {ConsentState} from '@/utils/google-ads-consents'
import {
    updateConsentsState as unmangedUpdateConsentsState,
    verifyInitialConsentsState,
} from '@/utils/google-ads-consents'

import {useHubspotConsent} from './context'

type ManageConsentHook = {
    /**
     * @deprecated
     * This function is deprecated and will be removed in the near future.
     * Use Hubspot consent management instead.
     */
    updateConsentsState: (consentState: ConsentState) => void
}

/**
 * Hook to manage the consent state.
 *
 * @deprecated
 * This hook is deprecated and will be removed in the near future.
 * Use Hubspot consent management instead.
 *
 * @note
 * If Hubspot consent is enabled, then consent state will not be updated.
 * This is intended, as Hubspot will manage the consent state.
 *
 * @returns {ManageConsentHook} - Function to set the consent state
 */
export const useManageConsent = (): ManageConsentHook => {
    const hubspotConsent = useHubspotConsent()

    /**
     * Verify the initial consent state.
     **/
    useEffect(() => {
        verifyInitialConsentsState({
            cookiePrefix: hubspotConsent.isEnabled ? 'managed' : 'unmanaged',
        })
    }, [hubspotConsent.isEnabled])

    /**
     * @deprecated
     * This function is deprecated and will be removed in the near future.
     * Use Hubspot consent management instead.
     */
    const updateConsentsState = useCallback(
        (consentState: ConsentState) => {
            if (hubspotConsent.isEnabled) {
                return
            }

            const legacyConsentParams = {
                ad_personalization: consentState,
                ad_user_data: consentState,
                ad_storage: consentState,
                analytics_storage: consentState,
            }

            unmangedUpdateConsentsState(legacyConsentParams, {
                cookiePrefix: 'unmanaged',
            })
        },
        [hubspotConsent],
    )

    return {updateConsentsState}
}
